import React from "react";
import { Container } from "react-bootstrap";

const GestionReportesPage = () => (
  <Container fluid className="py-3">
    <h3>Reportes Gestión</h3>
    <p>Reporte MVP: usar Dashboard Supervisor para productividad por usuario.</p>
  </Container>
);

export default GestionReportesPage;
